import React from "react";

import { OrdersMonthSummary } from "../../../../models";

import "./YearlyCard.scss";

export interface YearlyCardProps {
  months: OrdersMonthSummary[];
}

export function YearlyCard(props: YearlyCardProps) {
  const { months } = props;

  let [count, basePrice, deliveryFee, discount, total] = [0, 0, 0, 0, 0];
  months.forEach((m) => {
    count += m.count;
    basePrice += m.basePrice;
    deliveryFee += m.deliveryFee;
    discount += m.discount;
    total += m.total;
  });
  const totalSummary: OrdersMonthSummary = {
    month: "Total",
    count,
    basePrice,
    deliveryFee,
    discount,
    total,
  };

  const formatCurrency = (
    amount: number,
    currencyCode: string = "USD"
  ): string => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 0,
    });

    return formatter.format(amount);
  };

  const renderItem1 = (item: OrdersMonthSummary): React.ReactNode => {
    return (
      <div className="itemContainer1">
        <div className="monthContainer1">
          <div className="monthdiv1">{item.month}</div>

          <div className="totalContainer1">
            <div className="totalLabel1">Total</div>
            <div className="totaldiv1">{formatCurrency(item.total)}</div>
          </div>
        </div>

        <div className="itemValuesContainer1">
          <div className="valueContainer1">
            <div className="valueLabel1">Orders #</div>
            <div className="valuediv1">{item.count}</div>
          </div>

          <div className="verticalDivider" />

          <div className="valueContainer1">
            <div className="valueLabel1">Base price</div>
            <div className="valuediv1">{formatCurrency(item.basePrice)}</div>
          </div>

          <div className="verticalDivider" />

          <div className="valueContainer1">
            <div className="valueLabel1">Delivery fee</div>
            <div className="valuediv1">{formatCurrency(item.deliveryFee)}</div>
          </div>

          <div className="verticalDivider" />

          <div className="valueContainer1">
            <div className="valueLabel1">Discount</div>
            <div className="valuediv1">{formatCurrency(item.discount)}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="yearly-card-component">
      {months.map(renderItem1)}

      {renderItem1(totalSummary)}
    </div>
  );
}
